
if (document.querySelector('#loader')) {
    const loader = document.querySelector('#loader')
    const htmlBalise = document.querySelector('html')
    window.addEventListener('load', () => {
        loader.style.opacity = "0"
        loader.style.transition = "all .7s ease"
        htmlBalise.style.overflowY = "scroll"
        setTimeout(() => {
            loader.remove()
        },'2000')
    });
}